export enum ApiMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE'
}

export enum PostURL {
    LOGIN = '/api/login',
    REGISTER = '/api/register',
    VALIDATE_CAPTCHA = '/api/validate-recaptcha',
    CREATE_TAG = '/api/create-tag',
    UPDATE_TAG = '/api/update-tag',
    DELETE_TAG = '/api/delete-tag',
    CREATE_RELATED_TAG = '/api/create-related-tag',
    UPDATE_RELATED_TAG = '/api/update-related-tag',
    DELETE_RELATED_TAG = '/api/delete-related-tag',
    CREATE_ALIAS_TAG = '/api/create-alias-tag',
    UPDATE_ALIAS_TAG = '/api/update-alias-tag',
    DELETE_ALIAS_TAG = '/api/delete-alias-tag',
    GET_ALL_COUNTRIES = '/api/geo/get-all-countries',
    GET_REGIONS_BY_COUNTRY_CODE = '/api/geo/get-regions-by-country-code',
    GET_PLACES_BY_COUNTRY_AND_REGION_CODE = '/api/geo/get-places-by-country-and-region-code',
    DOWNLOAD_RECORD = '/api/v1/download-record',
    CREATE_CONTACT = '/api/v1/add-contact',
    UPDATE_CONTACT = '/api/v1/update-contact',
    DELETE_CONTACT = '/api/v1/delete-contact',
    CREATE_CONTACT_CATEGORY = '/api/v1/add-contact-category',
    UPDATE_CONTACT_CATEGORY = '/api/v1/update-contact-category',
    DELETE_CONTACT_CATEGORY = '/api/v1/delete-contact-category',
    GET_CONTACT_CATEGORIES = '/api/v1/get-contact-categories',
    SEND_INVITE_TO_CONTACT = '/api/v1/send-invite-to-contact',
    UPDATE_ACCOUNT_SETTING = '/api/account/update-account-setting',
    ADD_RECORD = '/api/v1/add-record',
    UPDATE_RECORD = '/api/v1/update-record',
    DELETE_RECORD = '/api/v1/delete-record',
    GET_USER_DATA_BY_EMAIL = '/api/get-user-data-by-email',
    GET_RECORDS_OF = '/api/v1/get-shared-records',
    SAVE_SEARCH = '/api/save-search-criteria',
    DELETE_SEARCH = '/api/delete-search-criteria',
    DELETE_ALL_SEARCH = '/api/delete-all-search-criteria',
    UPDATE_SEARCH = '/api/update-search-criteria',
    BULK_SET_LEGACY = '/api/v1/set-records-legacy-bulk',
    BULK_SET_PRIVATE_PUBLIC = '/api/v1/set-records-status-bulk',
    BULK_ADD_TAGS = '/api/v1/update-record-tags-relations-bulk',
    BULK_REMOVE_TAGS = '/api/v1/remove-tags-from-records-bulk',
    BULK_ADD_SHARED_ACCESS = '/api/v1/add-shared-access-to-records-bulk',
    BULK_REMOVE_RECORDS = '/api/v1/delete-records-bulk',
    BULK_REMOVE_SHARED_ACCESS = '/api/v1/delete-shared-access-to-records-bulk',
    UPDATE_TAG_CONTACT_CATEGORY_RELATION = '/api/update-tag-contact-and-contact-categories-relations',
    UPDATE_RECORD_TAG_RELATIONS = '/api/v1/update-record-tags-relations',
    UPDATE_CONTACT_AND_CATEGORY_RELATION = '/api/v1/update-contacts-and-contact-categories-relations',
    UPDATE_RECORD_CONTACT_CATEGORY_RELATION = '/api/v1/update-record-contact-and-contact-categories-relations',
    DELETE_LIST_OF_TAGS_FROM_ALL_RECORDS = '/api/global-operations/delete-list-of-tags-from-all-records',
    DELETE_ALL_TAGS_FROM_ALL_RECORDS = '/api/global-operations/delete-all-tags-from-all-records',
    SET_LEGACY_NOW_FLAG = '/api/global-operations/set-legacy-now-flag',
    REPLACE_TAG_ON_RECORDS = '/api/global-operations/replace-tag-on-records',
    UPDATE_PROFILE_PICTURE = '/api/update-profile-picture',
    DELETE_PROFILE_PICTURE = '/api/delete-profile-picture',
    UPDATE_RECORD_IMAGE_ROTATION = '/api/v1/update-record-image-rotation',
    ACTIVATE_ACCOUNT = '/api/activate-account',
    SET_SYSTEM_ADMIN = '/api-admin/set-settings',
    RESEND_ACTIVATE_ACCOUNT_EMAIL = '/api/resend-activate-account-email',
    UPDATE_SUBSCRIBER = '/api-admin/change-user-subscription-role',
    ADD_UPDATE_GLOBAL_USER = '/api-admin/add-update-user',
    LOGIN_ADMIN = '/api-admin/login',
    LOGOUT = '/api/logout',
    RESEND_CONFIRMATION_EMAIL = '/api-admin/resend-confirmation-email',
    LOGOUT_ADMIN = '/api-admin/logout',
    GENERATE_TRANSLATIONS = '/api-admin/generate-translations',
    GET_CONTRIBUTOR_TAGS = '/api/v1/get-contribuitor-tags',
    MARK_AS_READ = '/api/v1/toggle-record-read-status',
    MARK_ALL_AS_READ = '/api/v1/mark-all-records-as-read',
    MARK_TOGGLE_NOTIFICATION_READ = '/api/v1/toggle-notification-read-status',
    MARK_ALL_NOTIFICATION_AS_READ = '/api/v1/mark-all-notifications-as-read',
    GET_FAMILY_TREE_CONTENT = '/api/v1/get-family-tree',
    ADD_FAMILY_TREE_NODE = '/api/v1/add-family-tree-node',
    TOGGLE_LEGACY_FAMILY_TREE_NODE = '/api/v1/toggle-family-tree-node-legacy-setting',
    CHANGE_ACCESSIBILITY_FAMILY_TREE_NODE = '/api/v1/update-family-tree-node-accessibility',
    TAG_SHARE_FAMILY_TREE_NODE = '/api/v1/update-family-tree-tags-relations',
    UPDATE_FAMILY_TREE_CONTACT_CATEGORY_RELATION = '/api/v1/update-family-tree-node-contact-and-contact-categories-relations',
    DELETE_FAMLIY_TREE_NODE = '/api/v1/delete-family-tree-node',
    UPDATE_FAMILY_TREE_NODE = '/api/v1/update-family-tree-node',
    ADD_SMART_FAMILY = '/api/v1/smart-add-relationships',
    CREATE_SELF_RELATION_NODE = '/api/v1/create-self-relation-node',
    UPDATE_USER_DISABLED_STATUS = '/api-admin/update-user-disabled-status',
    GET_ALL_FAMILY_MEMBERS = '/api/v1/get-family-members'
}

export enum GetURL {
    TAGS = '/api/get-tags',
    CONTACTS = '/api/v1/get-contacts',
    RECORDS = '/api/v1/get-records',
    GET_ACCOUNT_SETTING = '/api/account/get-settings',
    GET_SHARED_CONTACT = '/api/v1/get-shared-contacts',
    GET_RECORD = '/api/v1/get-record',
    GET_SEARCH = '/api/get-search-criterias',
    GET_RECORD_TYPE = '/api/v1/get-records-types',
    GET_SUBSCRIPTION = '/api/v1/get-subscription-plans',
    GET_CONTRIBUTOR_TAGS = '/api/v1/get-contribuitor-tags',
    GET_CONTACT_CATEGORIES_SHARED = '/api/get-all-contacts-and-contact-categories',
    GET_GLOBAL_OPERATIONS_CONFIGURATION = '/api/global-operations/get-configuration',
    GET_RECORD_IMAGE = '/api/v1/get-record-image',
    GET_USERS = '/api-admin/get-users',
    GET_RECORDS_SYSTEM_DEFAULTS = '/api/v1/get-records-system-defaults',
    GET_PROFILE_PICTURE = '/api/get-profile-picture',
    GET_ADMIN_SETTINGS = '/api-admin/get-settings',
    GET_SETTINGS = '/api/get-settings',
    GET_GLOBAL_STATS = '/api-admin/get-global-stats',
    GET_TAGS_SYSTEM_DEFAULTS = '/api/v1/get-tags-system-defaults',
    GET_CONTACT_VAULT = '/api/v1/get-contact-vaults',
    GET_PDF_CREDENTIAL = '/assets/adobe/api.json',
    GET_CONTACT_CATEGORY_VAULT = '/api/v1/get-contact-category-vaults',
    GET_CONTACT_VAULT_RECORDS = '/api/v1/get-contact-vault-records',
    GET_CONTACT_CATEGORY_VAULT_RECORDS = '/api/v1/get-contact-category-vault-records',
    GET_PUBLIC_VAULT_RECORDS = '/api/v1/get-public-vault-records',
    GET_MY_WILL_VAULT_RECORDS = '/api/v1/get-will-vault-records',
    GET_DASHBOARD_STATISTICS = '/api/v1/get-dashboard-statistics',
    GET_NOTIFICATION = '/api/v1/get-notifications',
    GET_ALL_FAMILY_TREE_NODE = '/api/v1/get-all-added-family-tree-nodes',
    GET_FAMILY_TREE_NODE_PICTURE = '/api/v1/get-family-tree-node-picture'
}

export enum DeleteURL {
    DELETE_CONTACT_VAULT = '/api/v1/delete-contact-vault',
    DELETE_CONTACT_CATEGORY_VAULT = '/api/v1/delete-contact-category-vault',
    DELETE_SINGLE_NOTIFICATION = '/api/v1/delete-notification',
    DELETE_ALL_NOTIFICATION = '/api/v1/delete-all-notifications'
}
